import { listenLoginEvent } from '@eastcoal/auth/utils/event'

import { loadScript } from '../utils'

import { WxobsParams } from './interface'

const SCRIPT_URL =
  'https://dev.weixin.qq.com/platform-console/proxy/assets/tel/px.min.js'
const DEFAULT_PARAMS: WxobsParams = {
  maskMode: 'no-mask',
  recordCanvas: false,
  projectId: '',
  iframe: false,
  // 错误监控使用 RUM
  console: true,
  // 错误监控使用 RUM
  network: true
}

export async function setupWxobs(params: Partial<typeof DEFAULT_PARAMS>) {
  try {
    sessionStorage.setItem('wxobs_start_timestamp', String(Date.now()))
    await loadScript(SCRIPT_URL)
    window.__startPX?.({
      ...DEFAULT_PARAMS,
      ...params
    })
    listenLoginEvent(store => {
      window.__wxobs__?.setCustomId(`${store.user?.id}`)
      window.__wxobs__?.setCustomProperties({
        username: store.user?.name,
        memberId: store.member.id,
        memberName: store.member.name
      })
    })
  } catch (error) {
    console.error('Error loading scripts:', error)
  }
}
